<template>
  <v-card height="480" max-height="480">
    <v-toolbar color="primary" dark fixed>
      <v-toolbar-title>Current Queue</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text class="overflow-auto" style="height: 400px">
      <v-simple-table class="overflow-auto">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Agent</th>
              <th class="text-left">🎟️</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(agent, index) in queue" :key="index">
              <td>{{ agent.first_name }} {{ agent.last_name }}</td>
              <td>{{ moment(agent.ticket_timestamp).fromNow() }}</td>
            </tr>
          </tbody></template
        >
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "@/plugins/axios";
import moment from "moment";
export default {
  name: "CurrentQueue",
  components: {},
  mounted() {
    this.getData();
    // 5 sec
    this.interval = setInterval(() => {
      this.getData();
    }, 5000);
  },
  methods: {
    getData() {
      axios.get("/api/v1/agents/list-live").then((res) => {
        this.queue = res.data;
      });
    },
  },
  data() {
    return {
      queue: [],
      moment: moment,
      interval: null,
    };
  },
};
</script>

<style lang="scss" scoped></style>
